let apiBaseUri = '/api'
if (process.env.NODE_ENV === 'development') {
  apiBaseUri = ''
}

export default {
  API_BASE_URI: apiBaseUri,
  from: {
    WX_MENU: 'wxMenu',
    WX_BROWSER: 'wxBrowser'
  },
  Strings: {
    APP_NAME: '潮玩娱乐空间',
    SLOGAN: '快乐时光',
    NO_AUTH: '未授权',
    NO_PAGE: '404',
    REQ_SUCCESS: '成功',
    SYS_BUSY_TIP: '网络繁忙!',
    DEFAULT_DEVICE_ALERT_MSG: '您好！请勿占座！请扫码体验游戏！'
  },
  Storage: {
    HOME_SELECTED_TAB: 'home-selected-tab',
    DELEGATE_SELECTED_TAB: 'delegate-selected-tab',
    DEVICE_ALERT_MSG: 'device-alert-msg',
    BRAND_NAME: 'brand-name'
  },
  DICT_STATUS: {
    0: '已停用',
    1: '已启用'
  },
  DICT_COUPON_OPERATOR_ROLE: {
    'MANAGER': '管理',
    'AUDITOR': '运营'
  },
  DICT_COUPON_TYPE: {
    'GAME_MINUTES': '游戏时间',
    'PACKET_DISCOUNT': '套餐折扣'
  },
  DICT_COUPON_GRAB_WAY: {
    'ONLINE_QRCODE': '活动码',
    'PAPER_COUPON': '纸质券',
    'OFFLINE_QRCODE': '发券商'
  },
  DICT_ACTIVITY_PROGRESS: {
    'PREPARING': '未开始',
    'ONGOING': '进行中',
    'FINISHED': '已结束'
  },
  DICT_USER_COUPON_STATUS: {
    'TO_EXCHANGE': '可用卡券',
    'EXCHANGED': '已用卡券'
  },
  DICT_COUPON_STATUS: {
    'INIT': '待领取',
    'TO_EXCHANGE': '待使用',
    'EXCHANGED': '已使用'
  }
}


// WEBPACK FOOTER //
// ./src/utils/Constants.js